import React from 'react';

import styles from './list-item-body.scss';

export const ListItemBody: React.FC<React.PropsWithChildren> = ({ children }) =>
  <div className={styles.bodyWrapper}>
    {children}
  </div>;
